import { type MaybeRef, toValue } from 'vue';

import { deleteProject } from './api';

export const deleteProjectMutation = (projectUuid: MaybeRef<string>) => ({
  mutationFn: () => deleteProject(toValue(projectUuid)),
});
